// Making a new JS component
// 1 - Replace locationList with new name ( 8 occurences in this file )
// 2 - All code goes into init()
// 3 - Save file as new name .js
var locationList = {
	name: 'locationList',
	componentInitSelector: '.location-lister',
	registerComponent: function() {
		if ( $(locationList.componentInitSelector).length ) {
			framework.registerComponent(locationList);
		}
	},
	initlocationList: function() {
        // Put your args and inits here with their options.

        // End
        log(config.application.name + " •• locationList in " + Math.round( performance.now() - framework.initComponents.componentInitTime) + " milliseconds" );
    },
	init: function() {
		var filters = ['.office'];
		var grid = [];

		for (var i = 0; i < $('.grid').length; i++) {
			grid[i] = $('.grid').eq(i).isotope({
				itemSelector: '.filteredItem'
			});
		}

		function filter() {
			for (var j = 0; j < grid.length; j++) {
				grid[j].isotope({ filter: filters.join(',') });
			}
		}

		filter();
		
		$('.location-lister').on('click', '.tabButton', function(event) {
			event.preventDefault();
			$('.location-lister .tabButton.is-active').removeClass('is-active');
			$(this).addClass('is-active');

			if ( $(this).index() === 0 ) {
				filters = [];
				filters.push('*');
				filter();
			} else if( $(this).index() === 1 ) {
				filters = [];
				filters.push('.office');
				filter();
			} else {
				filters = [];
				filters.push('.officePlus');
				filter();
			}
		})

		// End
		locationList.initlocationList();
	}
}

// Register self to the framework
locationList.registerComponent();